export const KailisStoryPart2 = {
    level: 5,
    name: 'Kailis Heretic',
    cpu1Name: 'Chimera',
    cpu2Name: 'Lamia',
    text: 'Greed and the thirst for power drove Kailis to seek absolute strength. And she found it in worshiping the god of Death.',
    classCss: 'map-kailis-part2-ico',
    cpu1: {
        id: 12,
        before: {
            type: 'comics',
            comicsSetting: {
                path: './img/stories/kailis_heretic/intro/',
                slideNumber: 9
            }
        },
        after: {
            player: {
                type: 'text',
                step: {
                    0: "So you're fast, but it's not the end yet.",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Ha! You are not fast enough!',
                }
            }
        }
    },
    cpu2: {
        id: 13,
        before: {
            type: 'text',
            step: {
                0: 'The one true God has many followers. Time will get acquainted with them.',
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0: "Not all followers of the god of death are worthy of him. Thank you for removing the weak.",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'The followers of the pitiful goddess of pleasure are so weak.',
                }
            }
        }
    },
    cpu3: {
        id: 14,
        before: {
            type: 'text',
            step: {
                0: 'The time of the decisive battle has come; now we will find out whose god is stronger.',
            }
        },
        after: {
            cpu: {
                type: 'text',
                step: {
                    0: 'Nothing surprising, the weak lose, the strong win.',
                }
            },
            player: {
                type: 'comics',
                comicsSetting: {
                    path: './img/stories/kailis_heretic/win/',
                    slideNumber: 10
                }
            }
        },

    },
    cpu4: {
        id: 39,
        before: {
            type: 'text',
            step: {
                0: '...Ambush!!! Ha-Ha-HA-a-a!',
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0: "This is not the end. We will meet again, more than once! <i>whispers</i> The true god has granted me immortality!",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Weakness, weakness, weakness — that’s the only thing the followers of the goddess of pleasure are capable of.',
                }
            }
        }
    },
}
